import { customRuleApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const RULES_ACTION_TYPE = createNamedActions('rules', {
  GET_RULES: 'GET_RULES',
  GET_RULE_BY_ID: 'GET_RULE_BY_ID',
  EDIT_RULE: 'EDIT_RULE',
  ADD_RULE: 'ADD_RULE',
  ADD_CLONED_RULES: 'ADD_CLONED_RULES',
  DELETE_RULE: 'DELETE_RULE',
  CLONE_RULE_HIERARCHICALLY: 'CLONE_RULE_HIERARCHICALLY',
  CLONE_RULE: 'CLONE_RULE',
});

const rules = new schema.Entity('rules', {}, { idAttribute: 'id' });

export const getRuleByIdAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await customRuleApi.getCustomRuleById(params);

  return dispatch({
    type: RULES_ACTION_TYPE.GET_RULE_BY_ID,
    payload: data,
  });
});

export const addRuleAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await customRuleApi.createCustomRule(body);

  return dispatch({
    type: RULES_ACTION_TYPE.ADD_RULE,
    payload: data,
  });
});

export const editRuleAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await customRuleApi.editCustomRule(body);

  return dispatch({
    type: RULES_ACTION_TYPE.EDIT_RULE,
    payload: data,
  });
});

export const deleteRuleAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await customRuleApi.deleteCustomRule(params);

  return dispatch({
    type: RULES_ACTION_TYPE.DELETE_RULE,
    payload: data,
  });
});

export const cloneRuleAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await customRuleApi.createCustomRuleClone(body);

  return dispatch({
    type: RULES_ACTION_TYPE.CLONE_RULE,
    payload: data,
  });
});

export const cloneRuleHierarchicallyAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await customRuleApi.createCustomRuleCloneHierarchically(body);

  return dispatch({
    type: RULES_ACTION_TYPE.CLONE_RULE_HIERARCHICALLY,
    payload: data,
  });
});

export const addRulesAction = data => ({
  type: RULES_ACTION_TYPE.GET_RULES,
  payload: normalize(data, [rules]).entities.rules,
});

export const addClonedRulesAction = data => ({
  type: RULES_ACTION_TYPE.ADD_CLONED_RULES,
  payload: data,
});
